/* Memorial page: live engraving preview on the wind catcher, variant picker, inscription ideas, add to cart with engraving details. */
(function () {
  var root = document.querySelector("[data-mem]");
  if (!root) return;
  var NS = "http://www.w3.org/2000/svg";
  var q = function (sel) { return root.querySelector(sel); };
  var engr = q("[data-mem-engr]");
  var form = q("[data-mem-form]");
  var variants = JSON.parse(q("[data-mem-variants]").textContent);
  var prices = JSON.parse(q("[data-mem-prices]").textContent);

  var FONTS = {
    classic: { family: "'Cormorant Garamond', Georgia, serif", weight: 600, nameSize: 30, script: false },
    script: { family: "'Pinyon Script', 'Snell Roundhand', cursive", weight: 400, nameSize: 34, script: true }
  };
  var SYMBOLS = {
    heart: "M0 4 C-6 -3 -13 1 -9 8 L0 16 L9 8 C13 1 6 -3 0 4 Z",
    dove: "M-12 6 C-6 6 -2 2 0 -4 C2 -8 7 -9 9 -6 L13 -7 L10 -3 C10 4 4 10 -4 10 L-10 14 L-8 9 Z",
    paw: "M0 3 C-6 3 -9 9 -6 12 C-3 14 3 14 6 12 C9 9 6 3 0 3 Z M-8 -2 a3 4 0 1 0 0.1 0 Z M8 -2 a3 4 0 1 0 0.1 0 Z M-3 -6 a3 4 0 1 0 0.1 0 Z M3 -6 a3 4 0 1 0 0.1 0 Z"
  };
  function checked(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : ""; }
  function field(name) { return form.querySelector('[data-mem-field="' + name + '"]'); }

  // usable width of the wind catcher at height y (follows the outline), in SVG units
  function room(y) { var t = Math.min(1, Math.max(0, (y - 40) / 174)); return (46 + t * 88) * 2 - 26; }

  function line(text, y, size, family, weight, spacing, italic) {
    if (!text) return;
    var el = document.createElementNS(NS, "text");
    el.setAttribute("x", 150); el.setAttribute("y", y);
    el.setAttribute("font-size", size); el.setAttribute("font-family", family); el.setAttribute("font-weight", weight);
    if (spacing) el.setAttribute("letter-spacing", spacing);
    if (italic) el.setAttribute("font-style", "italic");
    el.textContent = text;
    engr.appendChild(el);
    var max = room(y - size * 0.35);
    try { if (el.getComputedTextLength() > max) { el.setAttribute("textLength", max); el.setAttribute("lengthAdjust", "spacingAndGlyphs"); } } catch (e) {}
  }

  function sizeKey() { return checked("mem-size"); }
  function currentVariant() {
    var s = sizeKey(), c = checked("mem-color");
    return variants.find(function (v) { return v.size === s && v.color === c; });
  }

  function syncVariant() {
    var s = sizeKey();
    // colors offered for this size; disable sold out ones
    form.querySelectorAll('input[name="mem-color"]').forEach(function (inp) {
      var v = variants.find(function (x) { return x.size === s && x.color === inp.value; });
      inp.disabled = !v || !v.available;
      inp.closest(".mem-choice").hidden = !v;
    });
    var cur = form.querySelector('input[name="mem-color"]:checked');
    if (!cur || cur.disabled) {
      var first = form.querySelector('input[name="mem-color"]:not(:disabled)');
      if (first) first.checked = true;
    }
    var v = currentVariant();
    form.querySelector('[name="id"]').value = v ? v.id : "";
    q("[data-mem-price]").textContent = prices[s] || "";
    q("[data-mem-size-label]").textContent = s.replace(/"/g, "") + " in chime";
    var img = q(".mem-chime-img");
    if (v && v.image && img) img.src = v.image;
  }

  function draw() {
    while (engr.firstChild) engr.removeChild(engr.firstChild);
    var f = FONTS[checked("mem-font")] || FONTS.classic;
    var top = field("top").value, name = field("name").value.trim(), dates = field("dates").value.trim();
    var m1 = field("msg1").value.trim(), m2 = field("msg2").value.trim();
    var sym = checked("mem-symbol");
    var y = 108;
    if (sym && SYMBOLS[sym]) {
      var p = document.createElementNS(NS, "path");
      p.setAttribute("d", SYMBOLS[sym]); p.setAttribute("transform", "translate(150 " + (y - 22) + ") scale(.95)");
      engr.appendChild(p); y += 8;
    }
    line(top ? top.toUpperCase() : "", y, 10.5, "'Figtree', sans-serif", 600, 2.2);
    y += top ? 36 : 22;
    line(name, y, f.nameSize, f.family, f.weight, 0);
    y += 24;
    line(dates, y, 14, "'Cormorant Garamond', Georgia, serif", 600, 1.5);
    y += 34;
    var ms = f.script ? 21 : 16;
    line(m1, y, ms, f.family, f.weight, 0, !f.script);
    line(m2, y + ms + 3, ms, f.family, f.weight, 0, !f.script);

    setCount("name", name.length, 18);
    setCount("dates", dates.length, 15);
    setCount("msg", m1.length + m2.length, 44);
    q("[data-mem-add]").disabled = !(field("ok").checked && name.length > 0 && form.querySelector('[name="id"]').value);
  }
  function setCount(key, n, max) {
    var el = q('[data-mem-count="' + key + '"]');
    if (!el) return;
    el.textContent = n + " / " + max;
    el.classList.toggle("is-full", n >= max);
  }

  form.addEventListener("input", function () { draw(); });
  form.addEventListener("change", function (e) {
    if (e.target.name === "mem-size" || e.target.name === "mem-color") syncVariant();
    draw();
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var status = q("[data-mem-status]");
    var btn = q("[data-mem-add]");
    var msg = [field("msg1").value.trim(), field("msg2").value.trim()].filter(Boolean).join(" / ");
    var props = {
      "Engraving - Opening line": field("top").value || "None",
      "Engraving - Name": field("name").value.trim(),
      "Engraving - Dates": field("dates").value.trim() || "None",
      "Engraving - Message": msg || "None",
      "Engraving - Symbol": checked("mem-symbol") || "None",
      "Engraving - Lettering": checked("mem-font") === "script" ? "Script" : "Classic"
    };
    btn.disabled = true;
    status.textContent = "Adding to cart...";
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || "Could not add to cart");
        status.textContent = "Added. Taking you to your cart.";
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart";
      })
      .catch(function (err) { status.textContent = err.message + ". Please try again."; btn.disabled = false; });
  });

  // Inscription ideas
  var IDEAS = JSON.parse(q("[data-mem-ideas]").textContent);
  var tabs = q("[data-mem-tabs]"), list = q("[data-mem-idea-list]");
  function showTab(k) {
    tabs.querySelectorAll(".mem-tab").forEach(function (b) { b.setAttribute("aria-selected", b.dataset.k === k ? "true" : "false"); });
    list.innerHTML = "";
    IDEAS[k].forEach(function (it) {
      var li = document.createElement("li"); li.className = "mem-idea";
      var quote = document.createElement("q"); quote.textContent = it[1] + " " + it[2];
      var b = document.createElement("button"); b.type = "button"; b.textContent = "Try it";
      b.addEventListener("click", function () {
        field("top").value = it[0]; field("msg1").value = it[1]; field("msg2").value = it[2];
        if (k === "Pet") { var paw = form.querySelector('input[name="mem-symbol"][value="paw"]'); if (paw) paw.checked = true; }
        draw();
        q("#mem-engrave").scrollIntoView({ behavior: "smooth", block: "start" });
      });
      li.appendChild(quote); li.appendChild(b); list.appendChild(li);
    });
  }
  Object.keys(IDEAS).forEach(function (k) {
    var b = document.createElement("button"); b.className = "mem-tab"; b.type = "button"; b.setAttribute("role", "tab"); b.dataset.k = k; b.textContent = k;
    b.addEventListener("click", function () { showTab(k); });
    tabs.appendChild(b);
  });
  showTab(Object.keys(IDEAS)[0]);

  syncVariant();
  draw();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
})();
